export function getLeaderboardPanelPath(user) {
  return user ? "/" : "/feed/public";
}
